export default {
    topics: [
        {
            title: ' Cookie (Class) ',
            href: 'c-Cookie.html',
            attributes: { 'data-id': 'c-Cookie' },
            menu: { hasChildren: false },
            tocID: 'c-Cookie-d66e7614',
            next: 'c-Cookie-d66e7614',
        },
        {
            title: ' HttpServletRequest (Class) ',
            href: 'c-HttpServletRequest.html',
            attributes: { 'data-id': 'c-HttpServletRequest' },
            menu: { hasChildren: false },
            tocID: 'c-HttpServletRequest-d66e7686',
            next: 'c-HttpServletRequest-d66e7686',
        },
        {
            title: ' HttpServletResponse (Class) ',
            href: 'c-HttpServletResponse.html',
            attributes: { 'data-id': 'c-HttpServletResponse' },
            menu: { hasChildren: false },
            tocID: 'c-HttpServletResponse-d66e7839',
            next: 'c-HttpServletResponse-d66e7839',
        },
    ],
};

